<style>
  .txt {
    display: inline-block;
    width: 300px;
    white-space: nowrap;
    overflow: hidden;
    text-overflow: ellipsis;
  }
</style>

<div class="panel layout-row layout-align-center">
  @if (uploading) {
    <div>
      <simple-progress [message]="'Uploading ' + progressPercentage + '%'"></simple-progress>
    </div>
  } @else if (showUI || error) {
    <div style="width: 100%"
         class="layout-row-gap-025 layout-justify-between layout-align-center"
         fileDND [fileType]='fileType' fileInputId='fileElem'
         (filesDropped)="filesDropped($event)" (filesError)="handleError($event)" [maxFileSize]="MAX_FILE_SIZE">
      @if (error) {
        <span style="font-weight: bold">{{ error }}</span>
      } @else {
        <span class="txt" (click)="fileElem.click()">{{ dropCaption }}</span>
      }
      @if (showUI) {
        <button mat-raised-button (click)="fileElem.click()" [disabled]="disabled">{{ buttonText }}</button>
      }
    </div>
  }
  <input type="file" #fileElem [accept]="acceptableFiles" [multiple]="false" (change)="filesPicked($event)" hidden
         [disabled]="disabled">
</div>

